import React, { useEffect, useState } from 'react';
import FunctionsData from '../../../Functions/FunctionsData';

export default function CampaignOptedVets({ campaignData }) {
  const [vets, setVets] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    FunctionsData.fetchDataGet(
      FunctionsData.getApiUrl('/api/campaign/optedVets/') + campaignData.id,
      setVets,
      loading,
      setLoading
    );
  }, [campaignData]);

  if (loading) return <div>Loading...</div>;

  return (
    <div>
      {
        vets.map((vet) => (
          <div key={vet.id}>{vet.business_name}</div>
        ))
      }
    </div>
  );
}
